import { render, staticRenderFns } from "./Habeas.vue?vue&type=template&id=4845a1bc&scoped=true&"
import script from "./Habeas.vue?vue&type=script&lang=js&"
export * from "./Habeas.vue?vue&type=script&lang=js&"
import style0 from "./Habeas.vue?vue&type=style&index=0&id=4845a1bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845a1bc",
  null
  
)

export default component.exports